import React from 'react';

import { useWidgetStore } from '../state/store';

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};
const modalStyle: React.CSSProperties = {
  background: 'white',
  padding: 24,
  borderRadius: 8,
  maxWidth: 480,
  textAlign: 'center',
};

const MARKETPLACE_URL = 'https://marketplace.zoho.com/';

export function OAuthRevokedModal(): React.JSX.Element | null {
  const error = useWidgetStore((s) => s.error);
  if (!error || error.code !== 'oauth_revoked') return null;
  return (
    <div role="dialog" aria-modal="true" style={overlayStyle}>
      <div style={modalStyle}>
        <h2>La integración con Zoho ha sido revocada</h2>
        <p>Pide a tu administrador que reinstala la aplicación desde el Marketplace.</p>
        <p style={{ marginTop: 16 }}>
          <a href={MARKETPLACE_URL} target="_blank" rel="noopener noreferrer">Abrir Marketplace</a>
        </p>
        <button onClick={() => window.location.reload()} style={{ marginTop: 16 }}>
          Recargar
        </button>
      </div>
    </div>
  );
}
